import {Grid, GridItem, Tabs, Text, Box, Button} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {Patient} from '@cypro/engine/schema'
import {PatientInformation} from './patient-information'
import {EmergencyContact} from './emergency-contact'
import {Insurance} from './insurance'
import {Characteristics} from './characteristics'
import {AdminAndCare} from './admin-care'
import {LuBarcode, LuOctagonX} from 'react-icons/lu'
import {BarcodeDialog} from '@/shared/components/ui/barcode-dialog'
import {dialog} from '@cypro/ui/components'
import {StopAllTreatmentDialog} from './dialogs/stop-all-treatment-dialog'
import {useStopAllTreatmentSummary} from '@/modules/patients/hooks/use-stop-all-treatment-summary'
import {useCan} from '@/shared/hooks/use-permissions'
import {useIsDevEnv} from '@cypro/ui/hooks/use-current-env'

export function PatientAboutTab({patient}: {patient: Patient}) {
  const {t} = useTranslate('common')
  const canEditPrescriptions = useCan('prescriptions.edit')
  const {hasSomethingToStop} = useStopAllTreatmentSummary(patient.id)
  async function openBarcode() {
    await dialog.open('bar-code-sequence', {
      children: <BarcodeDialog barcode={`P:${patient.id}\n`} />,
      size: 'full',
    })
  }
  function openStopAllTreatment() {
    void dialog.open(`stop-all-treatment-${patient.id}`, {
      children: <StopAllTreatmentDialog patient={patient} />,
      contentProps: {minWidth: '28vw'},
    })
  }

  const isDev = useIsDevEnv()

  return (
    <Tabs.Content
      value="about"
      spaceY="8"
      display="flex"
      flexDirection="column"
      flex="1"
      minHeight="0"
      overflowY="auto"
    >
      <Box display="flex" justifyContent={'space-between'} alignItems="center" width="100%">
        <Text fontSize="md" fontWeight="medium">
          {t('about')}
        </Text>
        <Box display="flex" alignItems="center" gap="4">
          <Button size="md" variant="plain" colorPalette="cyan" paddingInline="0" onClick={() => openBarcode()}>
            <LuBarcode />
            <Text fontSize="sm" fontWeight="medium">
              {t('see_barcode')}
            </Text>
          </Button>
          {isDev && canEditPrescriptions && (
            <Button
              size="md"
              colorPalette="red"
              variant="plain"
              paddingInline="0"
              p="3"
              disabled={!hasSomethingToStop}
              onClick={() => {
                openStopAllTreatment()
              }}
            >
              <LuOctagonX />
              <Text fontSize="sm" fontWeight="medium">
                {t('stop_all_treatment')}
              </Text>
            </Button>
          )}
        </Box>
      </Box>
      <Grid templateColumns={{base: '1fr', xl: '2fr 1fr'}} gap="8" alignItems="start">
        <GridItem display="flex" flexDirection="column" gap="8">
          <PatientInformation patient={patient} />
          <AdminAndCare patient={patient} />
        </GridItem>

        <GridItem display="flex" flexDirection="column" gap="8">
          <EmergencyContact patient={patient} />
          <Insurance patient={patient} />
          <Characteristics patient={patient} />
        </GridItem>
      </Grid>
    </Tabs.Content>
  )
}
